import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button, FormGroup, FormLabel, Collapse, Row, Col, FormSelect, Card } from 'react-bootstrap';
import { setUserPreference } from '../../redux/modules/user-profile/user-profile-middleware';
import FilterButtonGroup from './FilterButtonGroup';
import { messages } from '../../containers/Filter/Filter.i18n';

function buildDropdownOption(option) {
  const optValue = JSON.stringify(option.optionValue);
  return (
      <option
        key={optValue}
        value={optValue}
      >
        {option.optionText}
      </option>
  );
}

class FilterPanel extends React.Component {
  constructor() {
    super();

    this.handleButtonClickEvent = this.handleButtonClickEvent.bind(this);
    this.handleClearFilterEvent = this.handleClearFilterEvent.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    this.handleFilterChanged(JSON.parse(event.target.value));
  }

  handleButtonClickEvent(filterValue) {
    if (!filterValue || filterValue.length === 0) {
      return;
    }

    const filterOption = { ...this.props.filter,
      date: filterValue };

    this.props.dispatch(setUserPreference(this.props.keyDateFilterPreference, filterOption.date));
    this.handleFilterChanged(filterOption);
  }

  handleClearFilterEvent() {
    this.props.dispatch(setUserPreference(this.props.keyDateFilterPreference, this.props.clearFilter.date));
    this.handleFilterChanged(this.props.clearFilter);
  }

  handleFilterChanged(optionValue) {
    const action = this.props.createFilterChangeAction({ ...this.props.filter, ...optionValue });
    this.props.dispatch(action);
  }

  renderDateCol(dateValues) {
    return (
      <Col
        className="mb-2"
        xs={ dateValues.xsSize }
        sm={ dateValues.smSize }
        md={ dateValues.mdSize }
        lg={ dateValues.lgSize }
      >
        <FormGroup>
          <FormLabel htmlFor="date-filter-input-group">
            <FormattedMessage {...messages.filter.date} />
          </FormLabel>
          <div>
            <FilterButtonGroup
              handleClickEvent={this.handleButtonClickEvent}
              {...dateValues}
            />
          </div>
        </FormGroup>
      </Col>
    );
  }

  renderFilterCol(dropdownConfig) {
    return (
    <Col
      className="mb-2"
      xs={ dropdownConfig.xsSize }
      sm={ dropdownConfig.smSize }
      md={ dropdownConfig.mdSize }
      lg={ dropdownConfig.lgSize }
      key={JSON.stringify(dropdownConfig.id)}
    >
      <FormGroup>
        <FormLabel htmlFor={dropdownConfig.id}>
          <FormattedMessage {...dropdownConfig.label} />
        </FormLabel>
        <FormSelect
          onChange={this.onChange}
          value={JSON.stringify(dropdownConfig.list.value)}
          id={dropdownConfig.id}
        >
          {dropdownConfig.list.options.map(buildDropdownOption)}
        </FormSelect>
      </FormGroup>
    </Col>);
  }

  render() {
    const {
      isOpen,
      dateValues,
      filterValues,
    } = this.props;

    return (
        <Collapse in={isOpen}>
          <Card className="mb-3" bg="light">
            <Card.Body>
              <Row>
                <Col>
                  <Button
                    variant="link"
                    className="w-auto float-right"
                    onClick={this.handleClearFilterEvent}
                  >
                    <FormattedMessage {...messages.filter.clearFilter} />
                  </Button>
                </Col>
              </Row>
              <Row>
                  { this.renderDateCol(dateValues) }
                  { filterValues.map(this.renderFilterCol.bind(this)) }
              </Row>
            </Card.Body>
          </Card>
        </Collapse>
    );
  }
}

FilterPanel.propTypes = {
  dispatch: PropTypes.func,
  createFilterChangeAction: PropTypes.func,
  isOpen: PropTypes.bool,
  dateValues: PropTypes.object,
  filterValues: PropTypes.array,
  filter: PropTypes.object,
  keyDateFilterPreference: PropTypes.string,
  clearFilter: PropTypes.object,
};

export default connect()(FilterPanel);